/* eslint-disable no-unused-vars */
import {useEffect, useRef} from "react";
import clsx from "clsx";
import * as Yup from "yup";
import {useHistory} from "react-router-dom";
import {DashboardLayout} from "components/Layout";
import {Formik} from "formik";
import {SubmitButton} from "components/Button";
import {useToast} from "hooks/useToast";
import {convertErrorMessageFormat} from "utils/converter";
import {useEditMedicineUnit, useDetailMedicineUnit} from "hooks/SuperAdmin/MedicineUnit";
import {CircleLoader} from "components/Loader";
import {FormCard} from "components/Form";
import {useParams} from "react-router-dom";

const FormSchemaValidation = Yup.object().shape({
	name: Yup.string().required("Nama unit obat wajib di isi"),
	isInternalMedicine: Yup.boolean(),
});
const FormInitialValues = {name: "", isInternalMedicine: false};

export function MedicineUnitEditPage() {
	const {showToast} = useToast();
	const formikRef = useRef();
	const history = useHistory();
	const params = useParams();
	const {id} = params;
	const {isLoading: loadingFetcing, error, isError, data: detailMedicineUnit} = useDetailMedicineUnit(id);
	const {mutate, isLoading: isSubmitting} = useEditMedicineUnit();
	const handleSubmit = formData => {
		mutate(
			{id, ...formData},
			{
				onSuccess: () => {
					showToast("success", "Data berhasil diperbarui");
					history.push("/unit-obat");
				},
				onError: res => {
					showToast("error", convertErrorMessageFormat(res.response.status, res.response.data.message), null);
				},
			},
		);
	};

	useEffect(() => {
		if (detailMedicineUnit) {
			formikRef.current.setFieldValue("name", detailMedicineUnit?.data?.name);
			formikRef.current.setFieldValue(
				"isInternalMedicine",
				detailMedicineUnit?.data?.isInternalMedicine || false,
			);
		}
	}, [detailMedicineUnit]);

	if (loadingFetcing) {
		return (
			<DashboardLayout>
				<FormCard title="Edit Unit Obat">
					<CircleLoader />
				</FormCard>
			</DashboardLayout>
		);
	}

	return (
		<DashboardLayout>
			<Formik
				initialValues={FormInitialValues}
				innerRef={formikRef}
				validationSchema={FormSchemaValidation}
				onSubmit={handleSubmit}>
				{({handleSubmit, handleBlur, handleChange, values, errors, touched}) => (
					<FormCard
						backTitle="Daftar List Unit Obat"
						title="Edit Unit Obat"
						onBackButtonClick={() => history.push("/unit-obat")}>
						<div class="row gx-2 mb-5">
							<div class="col-sm-6 col-6">
								<div class="setting-item">
									<label class="setting-label required">Nama Unit Obat</label>
									<input
										class={clsx(
											"form-control",
											touched?.name && errors?.name && "form-control-error",
										)}
										disabled={isSubmitting}
										name="name"
										placeholder=""
										type="text"
										value={values?.name}
										onBlur={handleBlur}
										onChange={handleChange}
									/>
									{touched?.name && errors.name && (
										<p className="form-error-item-message">{errors.name}</p>
									)}
								</div>
							</div>
							<div class="col-sm-6 col-6">
								<div class="setting-item">
									<label class="setting-label">Internal Medicine</label>
									<div class="form-check">
										<input
											checked={values?.isInternalMedicine}
											class="form-check-input"
											disabled={isSubmitting}
											id="isInternalMedicine"
											name="isInternalMedicine"
											type="checkbox"
											onChange={handleChange}
										/>
										<label class="form-check-label" for="isInternalMedicine">
											Is Internal Medicine
										</label>
									</div>
								</div>
							</div>
						</div>

						<div class="text-center my-3">
							<SubmitButton
								className="btn btn-orange d-inline-block mw-250"
								disabled={!FormSchemaValidation.isValidSync(values)}
								loading={isSubmitting}
								text="Simpan Perubahan"
								onClick={handleSubmit}
							/>
						</div>
					</FormCard>
				)}
			</Formik>
		</DashboardLayout>
	);
}
